<template>
  <PopupButton placement="top" :offset="3">
    <template #button>
      <div class="indicator">
        <div class="btn btn-neutral btn-sm">{{ text }}</div>
      </div>
    </template>

    <template #popup>
      <div class="px-4 py-3 flex flex-col gap-3 min-w-[400px] md:min-w-[512px]">
        <ConditionTypeEdit
          :modelValue="modelValue"
          @update:modelValue="(v) => $emit('update:modelValue', v)"
        />

        <div class="flex justify-center items-center gap-3">
          <button
            v-if="parentLogic != 'Not'"
            class="btn btn-sm btn-primary"
            @click="$emit('update:modelValue', { Not: modelValue })"
          >
            Not
          </button>

          <button
            class="btn btn-sm btn-primary"
            @click="$emit('update:modelValue', { And: [modelValue, 'Always'] })"
          >
            And
          </button>

          <button
            class="btn btn-sm btn-primary"
            @click="$emit('update:modelValue', { Or: [modelValue, 'Always'] })"
          >
            Or
          </button>

          <button
            class="btn btn-sm btn-neutral"
            @click="$emit('update:modelValue', null)"
          >
            Delete
          </button>
        </div>
      </div>
    </template>
  </PopupButton>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { assertUnreachable } from "@/utils";
import { KeyAction } from "@/keyboard";
import {
  ConditionValue,
  ConditionTypeLogic,
  isCondLed,
  isCondRole,
  isCondUsbOn,
  isCondPressed,
  isCondKeyAction,
  isCondKeyPressed,
  isCondLayer,
  isCondAlways,
  isCondBootloaderAllowed,
} from "@/keyboard/leds";
import PopupButton from "@/components/utils/PopupButton.vue";
import ConditionTypeEdit from "@/components/leds/ConditionTypeEdit.vue";

const props = defineProps<{
  modelValue: ConditionValue;
  parentLogic?: ConditionTypeLogic;
}>();

defineEmits<{
  (_e: "update:modelValue", _value?: ConditionValue): void;
}>();

const keyActionText = (a: KeyAction): string =>
  a == "Trans"
    ? "Transparent"
    : a == "DefaultLayer"
    ? "Default Layer"
    : a == "MultipleActions"
    ? "Multiple Actions"
    : a == "MultipleKeyCodes"
    ? "Multiple Keycodes"
    : a;

const text = computed(() => {
  const c = props.modelValue;
  if (isCondAlways(c)) return "Always";
  else if (isCondUsbOn(c)) return "USB ON";
  else if (isCondLed(c)) return `${c.Led}`;
  else if (isCondRole(c)) return `${c.Role}`;
  else if (isCondPressed(c)) return "Pressed";
  else if (isCondKeyAction(c)) return `${keyActionText(c.KeyAction)}`;
  else if (isCondKeyPressed(c))
    return `Pressed (${c.KeyPressed[0]}, ${c.KeyPressed[1]})`;
  else if (isCondLayer(c)) return `Layer ${c.Layer}`;
  else if (isCondBootloaderAllowed(c)) return "Boot Allowed";
  else return assertUnreachable(c);
});
</script>
